import React, { useContext, useState } from "react";
import { Alert, Box, Paper, Snackbar } from "@mui/material";
import { TableContainer } from "@mui/material";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { del, post } from "../../../Services/tokenConfig";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { IAlimento, INecessidadesDia } from "../../../Interfaces/eficiencia_alimentar/planoAlimentar_GrupoHomo";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { StyledTableCell, StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { func_print } from "../../../Func_genericas/func_print";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import LoadingVulpes from "../../../Styles/Loader/loading";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { IGrupos_Homo_Eficiencia_Alimentar } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import BasicPopover from "../../../Components/Popover";

interface IAlimentoProps {
  alimento_composto_1: number | undefined;
  alimento_composto_2: number | undefined;
  alimento_composto_3: number | undefined;
  alimento_composto_4: number | undefined;
  alimento_composto_5: number | undefined;
  alimento_composto_6: number | undefined;
  alimento_composto_7: number | undefined;
  alimento_composto_8: number | undefined;
  alimento_composto_total: number | undefined;
  tabela: IAlimento | undefined;
  setTabela: React.Dispatch<React.SetStateAction<IAlimento | undefined>>;
  especie_ou_lote_homegenio_selecionada: IGrupos_Homo_Eficiencia_Alimentar | undefined;
  set_necessidades_dia: React.Dispatch<React.SetStateAction<INecessidadesDia | undefined>>;

}

export const AlimentoCompostoGH: React.FC<IAlimentoProps> = ({
  alimento_composto_1,
  alimento_composto_2,
  alimento_composto_3,
  alimento_composto_4,
  alimento_composto_5,
  alimento_composto_6,
  alimento_composto_7,
  alimento_composto_8,
  alimento_composto_total,
  tabela,
  setTabela,
  especie_ou_lote_homegenio_selecionada,
  set_necessidades_dia
}) => {
  const auth = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);

  const [obj_tabela_editar, set_obj_tabela_editar] = useState<IAlimento>();

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const [create, setCreate] = useState(false);
  const [editRow, setEditRow] = useState(false);
  const [idToDelete, setIdToDelete] = useState<number | null | undefined>(null);
  const [openDelete, setOpenDelete] = React.useState(false);

  const [error_camp_1_proteina_bruta, set_error_camp_1_proteina_bruta] = useState<boolean>(false);
  const [error_camp_2_proteina_bruta, set_error_camp_2_proteina_bruta] = useState<boolean>(false);
  const [error_camp_3_proteina_bruta, set_error_camp_3_proteina_bruta] = useState<boolean>(false);
  const [error_camp_4_proteina_bruta, set_error_camp_4_proteina_bruta] = useState<boolean>(false);
  const [error_camp_5_proteina_bruta, set_error_camp_5_proteina_bruta] = useState<boolean>(false);
  const [error_camp_6_proteina_bruta, set_error_camp_6_proteina_bruta] = useState<boolean>(false);
  const [error_camp_7_proteina_bruta, set_error_camp_7_proteina_bruta] = useState<boolean>(false);
  const [error_camp_8_proteina_bruta, set_error_camp_8_proteina_bruta] = useState<boolean>(false);

  const [error_camp_1_gordura_bruta, set_error_camp_1_gordura_bruta] = useState<boolean>(false);
  const [error_camp_2_gordura_bruta, set_error_camp_2_gordura_bruta] = useState<boolean>(false);
  const [error_camp_3_gordura_bruta, set_error_camp_3_gordura_bruta] = useState<boolean>(false);
  const [error_camp_4_gordura_bruta, set_error_camp_4_gordura_bruta] = useState<boolean>(false);
  const [error_camp_5_gordura_bruta, set_error_camp_5_gordura_bruta] = useState<boolean>(false);
  const [error_camp_6_gordura_bruta, set_error_camp_6_gordura_bruta] = useState<boolean>(false);
  const [error_camp_7_gordura_bruta, set_error_camp_7_gordura_bruta] = useState<boolean>(false);
  const [error_camp_8_gordura_bruta, set_error_camp_8_gordura_bruta] = useState<boolean>(false);

  const [error_camp_1_fosforo_total, set_error_camp_1_fosforo_total] = useState<boolean>(false);
  const [error_camp_2_fosforo_total, set_error_camp_2_fosforo_total] = useState<boolean>(false);
  const [error_camp_3_fosforo_total, set_error_camp_3_fosforo_total] = useState<boolean>(false);
  const [error_camp_4_fosforo_total, set_error_camp_4_fosforo_total] = useState<boolean>(false);
  const [error_camp_5_fosforo_total, set_error_camp_5_fosforo_total] = useState<boolean>(false);
  const [error_camp_6_fosforo_total, set_error_camp_6_fosforo_total] = useState<boolean>(false);
  const [error_camp_7_fosforo_total, set_error_camp_7_fosforo_total] = useState<boolean>(false);
  const [error_camp_8_fosforo_total, set_error_camp_8_fosforo_total] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");

  const [error_camp_1_organoleticos, set_error_camp_1_organoleticos] = useState<boolean>(false);
  const [error_camp_2_organoleticos, set_error_camp_2_organoleticos] = useState<boolean>(false);
  const [error_camp_3_organoleticos, set_error_camp_3_organoleticos] = useState<boolean>(false);
  const [error_camp_4_organoleticos, set_error_camp_4_organoleticos] = useState<boolean>(false);
  const [error_camp_5_organoleticos, set_error_camp_5_organoleticos] = useState<boolean>(false);
  const [error_camp_6_organoleticos, set_error_camp_6_organoleticos] = useState<boolean>(false);
  const [error_camp_7_organoleticos, set_error_camp_7_organoleticos] = useState<boolean>(false);
  const [error_camp_8_organoleticos, set_error_camp_8_organoleticos] = useState<boolean>(false);

  const [error_camp_1_nutritivos, set_error_camp_1_nutritivos] = useState<boolean>(false);
  const [error_camp_2_nutritivos, set_error_camp_2_nutritivos] = useState<boolean>(false);
  const [error_camp_3_nutritivos, set_error_camp_3_nutritivos] = useState<boolean>(false);
  const [error_camp_4_nutritivos, set_error_camp_4_nutritivos] = useState<boolean>(false);
  const [error_camp_5_nutritivos, set_error_camp_5_nutritivos] = useState<boolean>(false);
  const [error_camp_6_nutritivos, set_error_camp_6_nutritivos] = useState<boolean>(false);
  const [error_camp_7_nutritivos, set_error_camp_7_nutritivos] = useState<boolean>(false);
  const [error_camp_8_nutritivos, set_error_camp_8_nutritivos] = useState<boolean>(false);

  const [error_camp_1_ambientais, set_error_camp_1_ambientais] = useState<boolean>(false);
  const [error_camp_2_ambientais, set_error_camp_2_ambientais] = useState<boolean>(false);
  const [error_camp_3_ambientais, set_error_camp_3_ambientais] = useState<boolean>(false);
  const [error_camp_4_ambientais, set_error_camp_4_ambientais] = useState<boolean>(false);
  const [error_camp_5_ambientais, set_error_camp_5_ambientais] = useState<boolean>(false);
  const [error_camp_6_ambientais, set_error_camp_6_ambientais] = useState<boolean>(false);
  const [error_camp_7_ambientais, set_error_camp_7_ambientais] = useState<boolean>(false);
  const [error_camp_8_ambientais, set_error_camp_8_ambientais] = useState<boolean>(false);

  const [error_camp_1_melhoradores, set_error_camp_1_melhoradores] = useState<boolean>(false);
  const [error_camp_2_melhoradores, set_error_camp_2_melhoradores] = useState<boolean>(false);
  const [error_camp_3_melhoradores, set_error_camp_3_melhoradores] = useState<boolean>(false);
  const [error_camp_4_melhoradores, set_error_camp_4_melhoradores] = useState<boolean>(false);
  const [error_camp_5_melhoradores, set_error_camp_5_melhoradores] = useState<boolean>(false);
  const [error_camp_6_melhoradores, set_error_camp_6_melhoradores] = useState<boolean>(false);
  const [error_camp_7_melhoradores, set_error_camp_7_melhoradores] = useState<boolean>(false);
  const [error_camp_8_melhoradores, set_error_camp_8_melhoradores] = useState<boolean>(false);

  const [error_camp_1_estabilizadores, set_error_camp_1_estabilizadores] = useState<boolean>(false);
  const [error_camp_2_estabilizadores, set_error_camp_2_estabilizadores] = useState<boolean>(false);
  const [error_camp_3_estabilizadores, set_error_camp_3_estabilizadores] = useState<boolean>(false);
  const [error_camp_4_estabilizadores, set_error_camp_4_estabilizadores] = useState<boolean>(false);
  const [error_camp_5_estabilizadores, set_error_camp_5_estabilizadores] = useState<boolean>(false);
  const [error_camp_6_estabilizadores, set_error_camp_6_estabilizadores] = useState<boolean>(false);
  const [error_camp_7_estabilizadores, set_error_camp_7_estabilizadores] = useState<boolean>(false);
  const [error_camp_8_estabilizadores, set_error_camp_8_estabilizadores] = useState<boolean>(false);

  const [error_camp_1_zootecnicos, set_error_camp_1_zootecnicos] = useState<boolean>(false);
  const [error_camp_2_zootecnicos, set_error_camp_2_zootecnicos] = useState<boolean>(false);
  const [error_camp_3_zootecnicos, set_error_camp_3_zootecnicos] = useState<boolean>(false);
  const [error_camp_4_zootecnicos, set_error_camp_4_zootecnicos] = useState<boolean>(false);
  const [error_camp_5_zootecnicos, set_error_camp_5_zootecnicos] = useState<boolean>(false);
  const [error_camp_6_zootecnicos, set_error_camp_6_zootecnicos] = useState<boolean>(false);
  const [error_camp_7_zootecnicos, set_error_camp_7_zootecnicos] = useState<boolean>(false);
  const [error_camp_8_zootecnicos, set_error_camp_8_zootecnicos] = useState<boolean>(false);

  const message_apenas_x = ("Os valores deste campo 'x'.");

  const contabilizar_x_e_valores_numericos = (
    value1: string | undefined,
    value2: string | undefined,
    value3: string | undefined,
    value4: string | undefined,
    value5: string | undefined,
    value6: string | undefined,
    value7: string | undefined,
    value8: string | undefined,
  ) => {
    let x_counter = 0

    if (value1?.includes('x')) {
      x_counter = x_counter + 1

    }
    if (value2?.includes('x')) {
      x_counter = x_counter + 1

    }
    if (value3?.includes('x')) {
      x_counter = x_counter + 1

    }
    if (value4?.includes('x')) {
      x_counter = x_counter + 1

    }
    if (value5?.includes('x')) {
      x_counter = x_counter + 1

    }
    if (value6?.includes('x')) {
      x_counter = x_counter + 1

    }
    if (value7?.includes('x')) {
      x_counter = x_counter + 1

    }
    if (value8?.includes('x')) {
      x_counter = x_counter + 1

    }
    return x_counter
  }
  const total_proteina_bruta_menor_6 = (camp_1_proteina_bruta: number | undefined, alimento_composto_1: number | undefined, camp_2_proteina_bruta: number | undefined, alimento_composto_2: number | undefined) => {
    if (Number.isNaN(camp_1_proteina_bruta) ||
      Number.isNaN(alimento_composto_1) ||
      camp_1_proteina_bruta === undefined ||
      alimento_composto_1 === undefined ||
      camp_1_proteina_bruta === null ||
      alimento_composto_1 === null
    ) {
      if (
        Number.isNaN(camp_2_proteina_bruta) ||
        Number.isNaN(alimento_composto_2) ||
        camp_2_proteina_bruta === undefined ||
        alimento_composto_2 === undefined ||
        camp_2_proteina_bruta === null ||
        alimento_composto_2 === null
      ) {

        return 0
      } else {

        let aux = (camp_2_proteina_bruta * alimento_composto_2) / alimento_composto_2
        return Number.isNaN(aux) ? 0 : aux

      }
    } else if (Number.isNaN(camp_2_proteina_bruta) ||
      Number.isNaN(alimento_composto_2) ||
      camp_2_proteina_bruta === undefined ||
      alimento_composto_2 === undefined ||
      camp_2_proteina_bruta === null ||
      alimento_composto_2 === null
    ) {

      if (
        Number.isNaN(camp_1_proteina_bruta) ||
        Number.isNaN(alimento_composto_1) ||
        camp_1_proteina_bruta === undefined ||
        alimento_composto_1 === undefined ||
        camp_1_proteina_bruta === null ||
        alimento_composto_1 === null
      ) {

        return 0
      } else {

        let aux = (camp_1_proteina_bruta * alimento_composto_1) / alimento_composto_1
        return Number.isNaN(aux) ? 0 : aux
      }
    } else {

      let aux = (camp_1_proteina_bruta * alimento_composto_1 + camp_2_proteina_bruta * alimento_composto_2) / (alimento_composto_1 + alimento_composto_2)
      return Number.isNaN(aux) ? 0 : aux


    }

  }
  const total_proteina_bruta_maior_ou_igual_6 = (alimento_composto_total: number | undefined, alimento_composto_1: number | undefined, alimento_composto_2: number | undefined, camp_3_proteina_bruta: number | undefined, alimento_composto_3: number | undefined, camp_4_proteina_bruta: number | undefined, alimento_composto_4: number | undefined, camp_5_proteina_bruta: number | undefined, alimento_composto_5: number | undefined, camp_6_proteina_bruta: number | undefined, alimento_composto_6: number | undefined, camp_7_proteina_bruta: number | undefined, alimento_composto_7: number | undefined, camp_8_proteina_bruta: number | undefined, alimento_composto_8: number | undefined) => {

    let aux = 0
    let aux_alimento_composto_total = 0
    let aux_alimento_composto_1 = 0
    let aux_alimento_composto_2 = 0
    if (!Number.isNaN(camp_3_proteina_bruta) && !Number.isNaN(alimento_composto_3) && !(camp_3_proteina_bruta === undefined) && !(alimento_composto_3 === undefined) && !(camp_3_proteina_bruta === null) && !(alimento_composto_3 === null)) {

      let aux1 = camp_3_proteina_bruta * alimento_composto_3
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)
    }
    if (!Number.isNaN(camp_4_proteina_bruta) && !Number.isNaN(alimento_composto_4) && !(camp_4_proteina_bruta === undefined) && !(alimento_composto_4 === undefined) && !(camp_4_proteina_bruta === null) && !(alimento_composto_4 === null)) {
      let aux1 = camp_4_proteina_bruta * alimento_composto_4
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_5_proteina_bruta) && !Number.isNaN(alimento_composto_5) && !(camp_5_proteina_bruta === undefined) && !(alimento_composto_5 === undefined) && !(camp_5_proteina_bruta === null) && !(alimento_composto_5 === null)) {
      let aux1 = camp_5_proteina_bruta * alimento_composto_5
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_6_proteina_bruta) && !Number.isNaN(alimento_composto_6) && !(camp_6_proteina_bruta === undefined) && !(alimento_composto_6 === undefined) && !(camp_6_proteina_bruta === null) && !(alimento_composto_6 === null)) {
      let aux1 = camp_6_proteina_bruta * alimento_composto_6
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_7_proteina_bruta) && !Number.isNaN(alimento_composto_7) && !(camp_7_proteina_bruta === undefined) && !(alimento_composto_7 === undefined) && !(camp_7_proteina_bruta === null) && !(alimento_composto_7 === null)) {
      let aux1 = camp_7_proteina_bruta * alimento_composto_7
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_8_proteina_bruta) && !Number.isNaN(alimento_composto_8) && !(camp_8_proteina_bruta === undefined) && !(alimento_composto_8 === undefined) && !(camp_8_proteina_bruta === null) && !(alimento_composto_8 === null)) {
      let aux1 = camp_8_proteina_bruta * alimento_composto_8
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }

    if (!Number.isNaN(alimento_composto_total) && !(alimento_composto_total === undefined) && !(alimento_composto_total === null)) {
      aux_alimento_composto_total = alimento_composto_total
    }
    if (!Number.isNaN(alimento_composto_1) && !(alimento_composto_1 === undefined) && !(alimento_composto_1 === null)) {
      aux_alimento_composto_1 = alimento_composto_1
    }
    if (!Number.isNaN(alimento_composto_2) && !(alimento_composto_2 === undefined) && !(alimento_composto_2 === null)) {
      aux_alimento_composto_2 = alimento_composto_2
    }
    let aux2 = aux / (aux_alimento_composto_total - aux_alimento_composto_1 - aux_alimento_composto_2)


    return Number.isNaN(aux2) ? 0 : aux2

  }
  const total_gordura_bruta = (alimento_composto_total: number | undefined, camp_1_gordura_bruta: number | undefined, alimento_composto_1: number | undefined, camp_2_gordura_bruta: number | undefined, alimento_composto_2: number | undefined, camp_3_gordura_bruta: number | undefined, alimento_composto_3: number | undefined, camp_4_gordura_bruta: number | undefined, alimento_composto_4: number | undefined, camp_5_gordura_bruta: number | undefined, alimento_composto_5: number | undefined, camp_6_gordura_bruta: number | undefined, alimento_composto_6: number | undefined, camp_7_gordura_bruta: number | undefined, alimento_composto_7: number | undefined, camp_8_gordura_bruta: number | undefined, alimento_composto_8: number | undefined) => {
    let aux = 0
    let aux_alimento_composto_total = 0
    if (!Number.isNaN(camp_1_gordura_bruta) && !Number.isNaN(alimento_composto_1) && !(camp_1_gordura_bruta === undefined) && !(alimento_composto_1 === undefined) && !(camp_1_gordura_bruta === null) && !(alimento_composto_1 === null)) {

      let aux1 = camp_1_gordura_bruta * alimento_composto_1
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)
    }
    if (!Number.isNaN(camp_2_gordura_bruta) && !Number.isNaN(alimento_composto_2) && !(camp_2_gordura_bruta === undefined) && !(alimento_composto_2 === undefined) && !(camp_2_gordura_bruta === null) && !(alimento_composto_2 === null)) {

      let aux1 = camp_2_gordura_bruta * alimento_composto_2
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)
    }
    if (!Number.isNaN(camp_3_gordura_bruta) && !Number.isNaN(alimento_composto_3) && !(camp_3_gordura_bruta === undefined) && !(alimento_composto_3 === undefined) && !(camp_3_gordura_bruta === null) && !(alimento_composto_3 === null)) {

      let aux1 = camp_3_gordura_bruta * alimento_composto_3
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)
    }
    if (!Number.isNaN(camp_4_gordura_bruta) && !Number.isNaN(alimento_composto_4) && !(camp_4_gordura_bruta === undefined) && !(alimento_composto_4 === undefined) && !(camp_4_gordura_bruta === null) && !(alimento_composto_4 === null)) {
      let aux1 = camp_4_gordura_bruta * alimento_composto_4
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_5_gordura_bruta) && !Number.isNaN(alimento_composto_5) && !(camp_5_gordura_bruta === undefined) && !(alimento_composto_5 === undefined) && !(camp_5_gordura_bruta === null) && !(alimento_composto_5 === null)) {
      let aux1 = camp_5_gordura_bruta * alimento_composto_5
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_6_gordura_bruta) && !Number.isNaN(alimento_composto_6) && !(camp_6_gordura_bruta === undefined) && !(alimento_composto_6 === undefined) && !(camp_6_gordura_bruta === null) && !(alimento_composto_6 === null)) {
      let aux1 = camp_6_gordura_bruta * alimento_composto_6
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_7_gordura_bruta) && !Number.isNaN(alimento_composto_7) && !(camp_7_gordura_bruta === undefined) && !(alimento_composto_7 === undefined) && !(camp_7_gordura_bruta === null) && !(alimento_composto_7 === null)) {
      let aux1 = camp_7_gordura_bruta * alimento_composto_7
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_8_gordura_bruta) && !Number.isNaN(alimento_composto_8) && !(camp_8_gordura_bruta === undefined) && !(alimento_composto_8 === undefined) && !(camp_8_gordura_bruta === null) && !(alimento_composto_8 === null)) {
      let aux1 = camp_8_gordura_bruta * alimento_composto_8
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }

    if (!Number.isNaN(alimento_composto_total) && !(alimento_composto_total === undefined) && !(alimento_composto_total === null)) {
      aux_alimento_composto_total = alimento_composto_total
    }

    let aux2 = aux / (aux_alimento_composto_total)


    return Number.isNaN(aux2) ? 0 : aux2

  }
  const total_fosforo_total = (alimento_composto_total: number | undefined, camp_1_gordura_bruta: number | undefined, alimento_composto_1: number | undefined, camp_2_gordura_bruta: number | undefined, alimento_composto_2: number | undefined, camp_3_gordura_bruta: number | undefined, alimento_composto_3: number | undefined, camp_4_gordura_bruta: number | undefined, alimento_composto_4: number | undefined, camp_5_gordura_bruta: number | undefined, alimento_composto_5: number | undefined, camp_6_gordura_bruta: number | undefined, alimento_composto_6: number | undefined, camp_7_gordura_bruta: number | undefined, alimento_composto_7: number | undefined, camp_8_gordura_bruta: number | undefined, alimento_composto_8: number | undefined) => {
    let aux = 0
    let aux_alimento_composto_total = 0
    if (!Number.isNaN(camp_1_gordura_bruta) && !Number.isNaN(alimento_composto_1) && !(camp_1_gordura_bruta === undefined) && !(alimento_composto_1 === undefined) && !(camp_1_gordura_bruta === null) && !(alimento_composto_1 === null)) {

      let aux1 = camp_1_gordura_bruta * alimento_composto_1
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)
    }
    if (!Number.isNaN(camp_2_gordura_bruta) && !Number.isNaN(alimento_composto_2) && !(camp_2_gordura_bruta === undefined) && !(alimento_composto_2 === undefined) && !(camp_2_gordura_bruta === null) && !(alimento_composto_2 === null)) {

      let aux1 = camp_2_gordura_bruta * alimento_composto_2
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)
    }
    if (!Number.isNaN(camp_3_gordura_bruta) && !Number.isNaN(alimento_composto_3) && !(camp_3_gordura_bruta === undefined) && !(alimento_composto_3 === undefined) && !(camp_3_gordura_bruta === null) && !(alimento_composto_3 === null)) {

      let aux1 = camp_3_gordura_bruta * alimento_composto_3
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)
    }
    if (!Number.isNaN(camp_4_gordura_bruta) && !Number.isNaN(alimento_composto_4) && !(camp_4_gordura_bruta === undefined) && !(alimento_composto_4 === undefined) && !(camp_4_gordura_bruta === null) && !(alimento_composto_4 === null)) {
      let aux1 = camp_4_gordura_bruta * alimento_composto_4
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_5_gordura_bruta) && !Number.isNaN(alimento_composto_5) && !(camp_5_gordura_bruta === undefined) && !(alimento_composto_5 === undefined) && !(camp_5_gordura_bruta === null) && !(alimento_composto_5 === null)) {
      let aux1 = camp_5_gordura_bruta * alimento_composto_5
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_6_gordura_bruta) && !Number.isNaN(alimento_composto_6) && !(camp_6_gordura_bruta === undefined) && !(alimento_composto_6 === undefined) && !(camp_6_gordura_bruta === null) && !(alimento_composto_6 === null)) {
      let aux1 = camp_6_gordura_bruta * alimento_composto_6
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_7_gordura_bruta) && !Number.isNaN(alimento_composto_7) && !(camp_7_gordura_bruta === undefined) && !(alimento_composto_7 === undefined) && !(camp_7_gordura_bruta === null) && !(alimento_composto_7 === null)) {
      let aux1 = camp_7_gordura_bruta * alimento_composto_7
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }
    if (!Number.isNaN(camp_8_gordura_bruta) && !Number.isNaN(alimento_composto_8) && !(camp_8_gordura_bruta === undefined) && !(alimento_composto_8 === undefined) && !(camp_8_gordura_bruta === null) && !(alimento_composto_8 === null)) {
      let aux1 = camp_8_gordura_bruta * alimento_composto_8
      aux = aux + (Number.isNaN(aux1) ? 0 : aux1)

    }

    if (!Number.isNaN(alimento_composto_total) && !(alimento_composto_total === undefined) && !(alimento_composto_total === null)) {
      aux_alimento_composto_total = alimento_composto_total
    }

    let aux2 = aux / (aux_alimento_composto_total)


    return Number.isNaN(aux2) ? 0 : aux2

  }
  const handleCancel = () => {
    setCreate(false);
    set_obj_tabela_editar(undefined);
    setEditRow(false);
  }

  const onInputChange = (event: any) => {
    const { name, value } = event.target;


    if (name === 'camp_1_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_1_organoleticos(false)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_1_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_2_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_2_organoleticos(false)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_2_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_3_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_3_organoleticos(false)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_3_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_4_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {

        set_error_camp_4_organoleticos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_4_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_5_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_5_organoleticos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_5_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_6_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_6_organoleticos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_6_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_7_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_7_organoleticos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_7_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_8_organoleticos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_8_organoleticos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_8_organoleticos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_1_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_1_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_1_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_2_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_2_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_2_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }
    } else if (name === 'camp_3_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_3_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_3_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_4_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_4_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_4_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_5_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_5_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_5_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_6_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_6_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_6_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_7_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_7_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_7_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_8_nutritivos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_8_nutritivos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_8_nutritivos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_1_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_1_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_1_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_2_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_2_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_2_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_3_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_3_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_3_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_4_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_4_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_4_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_5_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_5_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_5_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_6_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_6_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_6_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_7_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_7_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_7_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_8_ambientais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_8_ambientais(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_8_ambientais(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_1_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_1_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_1_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_2_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_2_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_2_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_3_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_3_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_3_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_4_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_4_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_4_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_5_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_5_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_5_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_6_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_6_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_6_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_7_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_7_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_7_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_8_melhoradores_digestinais') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_8_melhoradores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_8_melhoradores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_1_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_1_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_1_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_2_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_2_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_2_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_3_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_3_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_3_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_4_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_4_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_4_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_5_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_5_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_5_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_6_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_6_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_6_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_7_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_7_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_7_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_8_estabilizadores_floragastrica') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_8_estabilizadores(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_8_estabilizadores(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_1_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_1_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_1_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_2_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_2_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_2_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_3_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_3_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_3_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_4_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_4_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_4_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_5_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_5_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_5_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_6_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_6_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_6_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_7_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_7_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_7_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_8_outros_zootecnicos') {
      let valor_aux = value.toLowerCase().trim()
      if (/[a-zA-Z]/.test(value) && value.toLowerCase().includes('x') && valor_aux.length === 1) {
        set_error_camp_8_zootecnicos(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: valor_aux,
        }));
      } else {
        set_error_camp_8_zootecnicos(true)
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: value,
        }));
      }

    } else if (name === 'camp_1_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_1_proteina_bruta(true)
      } else {
        set_error_camp_1_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_2_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_2_proteina_bruta(true)
      } else {
        set_error_camp_2_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_3_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_3_proteina_bruta(true)
      } else {
        set_error_camp_3_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_4_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_4_proteina_bruta(true)
      } else {
        set_error_camp_4_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_5_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_5_proteina_bruta(true)
      } else {
        set_error_camp_5_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_6_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_6_proteina_bruta(true)
      } else {
        set_error_camp_6_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_7_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_7_proteina_bruta(true)
      } else {
        set_error_camp_7_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_8_proteina_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_8_proteina_bruta(true)
      } else {
        set_error_camp_8_proteina_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_1_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_1_gordura_bruta(true)
      } else {
        set_error_camp_1_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_2_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_2_gordura_bruta(true)
      } else {
        set_error_camp_2_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_3_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_3_gordura_bruta(true)
      } else {
        set_error_camp_3_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_4_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_4_gordura_bruta(true)
      } else {
        set_error_camp_4_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_5_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_5_gordura_bruta(true)
      } else {
        set_error_camp_5_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_6_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_6_gordura_bruta(true)
      } else {
        set_error_camp_6_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_7_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_7_gordura_bruta(true)
      } else {
        set_error_camp_7_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_8_gordura_bruta') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_8_gordura_bruta(true)
      } else {
        set_error_camp_8_gordura_bruta(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_1_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_1_fosforo_total(true)
      } else {
        set_error_camp_1_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_2_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_2_fosforo_total(true)
      } else {
        set_error_camp_2_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_3_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_3_fosforo_total(true)
      } else {
        set_error_camp_3_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_4_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_4_fosforo_total(true)
      } else {
        set_error_camp_4_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_5_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_5_fosforo_total(true)
      } else {
        set_error_camp_5_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_6_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_6_fosforo_total(true)
      } else {
        set_error_camp_6_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_7_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_7_fosforo_total(true)
      } else {
        set_error_camp_7_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_8_fosforo_total') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_8_fosforo_total(true)
      } else {
        set_error_camp_8_fosforo_total(false)

        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else {
      set_obj_tabela_editar((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    }


  };

  const handleSave = () => {
    if (editRow === true) {
      handleUpdatetabela();
    } else {
      handleSaveTabela();
    }
  }

  const handleSaveTabela = async () => {
    if (obj_tabela_editar === undefined) {
      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else
      try {
        let res = await post(auth.token.cookie_token, "new_alimento_composto_GH", {
          payload: {
            id_alimento: 0,
            camp_1_proteina_bruta: obj_tabela_editar.camp_1_proteina_bruta === undefined || obj_tabela_editar?.camp_1_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_1_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_1_proteina_bruta),
            camp_2_proteina_bruta: obj_tabela_editar.camp_2_proteina_bruta === undefined || obj_tabela_editar?.camp_2_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_2_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_2_proteina_bruta),
            camp_3_proteina_bruta: obj_tabela_editar.camp_3_proteina_bruta === undefined || obj_tabela_editar?.camp_3_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_3_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_3_proteina_bruta),
            camp_4_proteina_bruta: obj_tabela_editar.camp_4_proteina_bruta === undefined || obj_tabela_editar?.camp_4_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_4_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_4_proteina_bruta),
            camp_5_proteina_bruta: obj_tabela_editar.camp_5_proteina_bruta === undefined || obj_tabela_editar?.camp_5_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_5_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_5_proteina_bruta),
            camp_6_proteina_bruta: obj_tabela_editar.camp_6_proteina_bruta === undefined || obj_tabela_editar?.camp_6_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_6_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_6_proteina_bruta),
            camp_7_proteina_bruta: obj_tabela_editar.camp_7_proteina_bruta === undefined || obj_tabela_editar?.camp_7_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_7_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_7_proteina_bruta),
            camp_8_proteina_bruta: obj_tabela_editar.camp_8_proteina_bruta === undefined || obj_tabela_editar?.camp_8_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_8_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_8_proteina_bruta),
            camp_1_gordura_bruta: obj_tabela_editar.camp_1_gordura_bruta === undefined || obj_tabela_editar?.camp_1_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_1_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_1_gordura_bruta),
            camp_2_gordura_bruta: obj_tabela_editar.camp_2_gordura_bruta === undefined || obj_tabela_editar?.camp_2_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_2_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_2_gordura_bruta),
            camp_3_gordura_bruta: obj_tabela_editar.camp_3_gordura_bruta === undefined || obj_tabela_editar?.camp_3_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_3_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_3_gordura_bruta),
            camp_4_gordura_bruta: obj_tabela_editar.camp_4_gordura_bruta === undefined || obj_tabela_editar?.camp_4_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_4_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_4_gordura_bruta),
            camp_5_gordura_bruta: obj_tabela_editar.camp_5_gordura_bruta === undefined || obj_tabela_editar?.camp_5_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_5_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_5_gordura_bruta),
            camp_6_gordura_bruta: obj_tabela_editar.camp_6_gordura_bruta === undefined || obj_tabela_editar?.camp_6_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_6_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_6_gordura_bruta),
            camp_7_gordura_bruta: obj_tabela_editar.camp_7_gordura_bruta === undefined || obj_tabela_editar?.camp_7_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_7_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_7_gordura_bruta),
            camp_8_gordura_bruta: obj_tabela_editar.camp_8_gordura_bruta === undefined || obj_tabela_editar?.camp_8_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_8_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_8_gordura_bruta),
            camp_1_organoleticos: obj_tabela_editar.camp_1_organoleticos === undefined ? "" : (obj_tabela_editar.camp_1_organoleticos),
            camp_2_organoleticos: obj_tabela_editar.camp_2_organoleticos === undefined ? "" : (obj_tabela_editar.camp_2_organoleticos),
            camp_3_organoleticos: obj_tabela_editar.camp_3_organoleticos === undefined ? "" : (obj_tabela_editar.camp_3_organoleticos),
            camp_4_organoleticos: obj_tabela_editar.camp_4_organoleticos === undefined ? "" : (obj_tabela_editar.camp_4_organoleticos),
            camp_5_organoleticos: obj_tabela_editar.camp_5_organoleticos === undefined ? "" : (obj_tabela_editar.camp_5_organoleticos),
            camp_6_organoleticos: obj_tabela_editar.camp_6_organoleticos === undefined ? "" : (obj_tabela_editar.camp_6_organoleticos),
            camp_7_organoleticos: obj_tabela_editar.camp_7_organoleticos === undefined ? "" : (obj_tabela_editar.camp_7_organoleticos),
            camp_8_organoleticos: obj_tabela_editar.camp_8_organoleticos === undefined ? "" : (obj_tabela_editar.camp_8_organoleticos),
            camp_1_nutritivos: obj_tabela_editar.camp_1_nutritivos === undefined ? "" : (obj_tabela_editar.camp_1_nutritivos),
            camp_2_nutritivos: obj_tabela_editar.camp_2_nutritivos === undefined ? "" : (obj_tabela_editar.camp_2_nutritivos),
            camp_3_nutritivos: obj_tabela_editar.camp_3_nutritivos === undefined ? "" : (obj_tabela_editar.camp_3_nutritivos),
            camp_4_nutritivos: obj_tabela_editar.camp_4_nutritivos === undefined ? "" : (obj_tabela_editar.camp_4_nutritivos),
            camp_5_nutritivos: obj_tabela_editar.camp_5_nutritivos === undefined ? "" : (obj_tabela_editar.camp_5_nutritivos),
            camp_6_nutritivos: obj_tabela_editar.camp_6_nutritivos === undefined ? "" : (obj_tabela_editar.camp_6_nutritivos),
            camp_7_nutritivos: obj_tabela_editar.camp_7_nutritivos === undefined ? "" : (obj_tabela_editar.camp_7_nutritivos),
            camp_8_nutritivos: obj_tabela_editar.camp_8_nutritivos === undefined ? "" : (obj_tabela_editar.camp_8_nutritivos),
            camp_1_ambientais: obj_tabela_editar.camp_1_ambientais === undefined ? "" : (obj_tabela_editar.camp_1_ambientais),
            camp_2_ambientais: obj_tabela_editar.camp_2_ambientais === undefined ? "" : (obj_tabela_editar.camp_2_ambientais),
            camp_3_ambientais: obj_tabela_editar.camp_3_ambientais === undefined ? "" : (obj_tabela_editar.camp_3_ambientais),
            camp_4_ambientais: obj_tabela_editar.camp_4_ambientais === undefined ? "" : (obj_tabela_editar.camp_4_ambientais),
            camp_5_ambientais: obj_tabela_editar.camp_5_ambientais === undefined ? "" : (obj_tabela_editar.camp_5_ambientais),
            camp_6_ambientais: obj_tabela_editar.camp_6_ambientais === undefined ? "" : (obj_tabela_editar.camp_6_ambientais),
            camp_7_ambientais: obj_tabela_editar.camp_7_ambientais === undefined ? "" : (obj_tabela_editar.camp_7_ambientais),
            camp_8_ambientais: obj_tabela_editar.camp_8_ambientais === undefined ? "" : (obj_tabela_editar.camp_8_ambientais),
            camp_1_melhoradores_digestinais: obj_tabela_editar.camp_1_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_1_melhoradores_digestinais),
            camp_2_melhoradores_digestinais: obj_tabela_editar.camp_2_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_2_melhoradores_digestinais),
            camp_3_melhoradores_digestinais: obj_tabela_editar.camp_3_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_3_melhoradores_digestinais),
            camp_4_melhoradores_digestinais: obj_tabela_editar.camp_4_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_4_melhoradores_digestinais),
            camp_5_melhoradores_digestinais: obj_tabela_editar.camp_5_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_5_melhoradores_digestinais),
            camp_6_melhoradores_digestinais: obj_tabela_editar.camp_6_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_6_melhoradores_digestinais),
            camp_7_melhoradores_digestinais: obj_tabela_editar.camp_7_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_7_melhoradores_digestinais),
            camp_8_melhoradores_digestinais: obj_tabela_editar.camp_8_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_8_melhoradores_digestinais),
            camp_1_estabilizadores_floragastrica: obj_tabela_editar.camp_1_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_1_estabilizadores_floragastrica),
            camp_2_estabilizadores_floragastrica: obj_tabela_editar.camp_2_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_2_estabilizadores_floragastrica),
            camp_3_estabilizadores_floragastrica: obj_tabela_editar.camp_3_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_3_estabilizadores_floragastrica),
            camp_4_estabilizadores_floragastrica: obj_tabela_editar.camp_4_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_4_estabilizadores_floragastrica),
            camp_5_estabilizadores_floragastrica: obj_tabela_editar.camp_5_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_5_estabilizadores_floragastrica),
            camp_6_estabilizadores_floragastrica: obj_tabela_editar.camp_6_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_6_estabilizadores_floragastrica),
            camp_7_estabilizadores_floragastrica: obj_tabela_editar.camp_7_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_7_estabilizadores_floragastrica),
            camp_8_estabilizadores_floragastrica: obj_tabela_editar.camp_8_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_8_estabilizadores_floragastrica),
            camp_1_outros_zootecnicos: obj_tabela_editar.camp_1_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_1_outros_zootecnicos),
            camp_2_outros_zootecnicos: obj_tabela_editar.camp_2_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_2_outros_zootecnicos),
            camp_3_outros_zootecnicos: obj_tabela_editar.camp_3_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_3_outros_zootecnicos),
            camp_4_outros_zootecnicos: obj_tabela_editar.camp_4_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_4_outros_zootecnicos),
            camp_5_outros_zootecnicos: obj_tabela_editar.camp_5_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_5_outros_zootecnicos),
            camp_6_outros_zootecnicos: obj_tabela_editar.camp_6_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_6_outros_zootecnicos),
            camp_7_outros_zootecnicos: obj_tabela_editar.camp_7_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_7_outros_zootecnicos),
            camp_8_outros_zootecnicos: obj_tabela_editar.camp_8_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_8_outros_zootecnicos),
            camp_1_fosforo_total: obj_tabela_editar.camp_1_fosforo_total === undefined || obj_tabela_editar?.camp_1_fosforo_total === null ? 0 : obj_tabela_editar?.camp_1_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_1_fosforo_total),
            camp_2_fosforo_total: obj_tabela_editar.camp_2_fosforo_total === undefined || obj_tabela_editar?.camp_2_fosforo_total === null ? 0 : obj_tabela_editar?.camp_2_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_2_fosforo_total),
            camp_3_fosforo_total: obj_tabela_editar.camp_3_fosforo_total === undefined || obj_tabela_editar?.camp_3_fosforo_total === null ? 0 : obj_tabela_editar?.camp_3_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_3_fosforo_total),
            camp_4_fosforo_total: obj_tabela_editar.camp_4_fosforo_total === undefined || obj_tabela_editar?.camp_4_fosforo_total === null ? 0 : obj_tabela_editar?.camp_4_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_4_fosforo_total),
            camp_5_fosforo_total: obj_tabela_editar.camp_5_fosforo_total === undefined || obj_tabela_editar?.camp_5_fosforo_total === null ? 0 : obj_tabela_editar?.camp_5_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_5_fosforo_total),
            camp_6_fosforo_total: obj_tabela_editar.camp_6_fosforo_total === undefined || obj_tabela_editar?.camp_6_fosforo_total === null ? 0 : obj_tabela_editar?.camp_6_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_6_fosforo_total),
            camp_7_fosforo_total: obj_tabela_editar.camp_7_fosforo_total === undefined || obj_tabela_editar?.camp_7_fosforo_total === null ? 0 : obj_tabela_editar?.camp_7_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_7_fosforo_total),
            camp_8_fosforo_total: obj_tabela_editar.camp_8_fosforo_total === undefined || obj_tabela_editar?.camp_8_fosforo_total === null ? 0 : obj_tabela_editar?.camp_8_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_8_fosforo_total),
            total_bovinos_maior: total_proteina_bruta_maior_ou_igual_6(alimento_composto_total, alimento_composto_1, alimento_composto_2, obj_tabela_editar?.camp_3_proteina_bruta, alimento_composto_3, obj_tabela_editar?.camp_4_proteina_bruta, alimento_composto_4, obj_tabela_editar?.camp_5_proteina_bruta, alimento_composto_5, obj_tabela_editar?.camp_6_proteina_bruta, alimento_composto_6, obj_tabela_editar?.camp_7_proteina_bruta, alimento_composto_7, obj_tabela_editar?.camp_8_proteina_bruta, alimento_composto_8),
            total_bovinos_menor: total_proteina_bruta_menor_6(obj_tabela_editar?.camp_1_proteina_bruta, alimento_composto_1, obj_tabela_editar?.camp_2_proteina_bruta, alimento_composto_2),
            total_fosforo: total_fosforo_total(alimento_composto_total, obj_tabela_editar?.camp_1_fosforo_total, alimento_composto_1, obj_tabela_editar?.camp_2_fosforo_total, alimento_composto_2, obj_tabela_editar?.camp_1_fosforo_total, alimento_composto_3, obj_tabela_editar?.camp_4_fosforo_total, alimento_composto_4, obj_tabela_editar?.camp_5_fosforo_total, alimento_composto_5, obj_tabela_editar?.camp_6_fosforo_total, alimento_composto_6, obj_tabela_editar?.camp_7_fosforo_total, alimento_composto_7, obj_tabela_editar?.camp_8_fosforo_total, alimento_composto_8),
            total_gordura: total_gordura_bruta(alimento_composto_total, obj_tabela_editar?.camp_1_gordura_bruta, alimento_composto_1, obj_tabela_editar?.camp_2_gordura_bruta, alimento_composto_2, obj_tabela_editar?.camp_1_gordura_bruta, alimento_composto_3, obj_tabela_editar?.camp_4_gordura_bruta, alimento_composto_4, obj_tabela_editar?.camp_5_gordura_bruta, alimento_composto_5, obj_tabela_editar?.camp_6_gordura_bruta, alimento_composto_6, obj_tabela_editar?.camp_7_gordura_bruta, alimento_composto_7, obj_tabela_editar?.camp_8_gordura_bruta, alimento_composto_8),
            total_organoleticos: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_organoleticos, obj_tabela_editar?.camp_2_organoleticos, obj_tabela_editar?.camp_3_organoleticos, obj_tabela_editar?.camp_4_organoleticos,
              obj_tabela_editar?.camp_5_organoleticos, obj_tabela_editar?.camp_6_organoleticos, obj_tabela_editar?.camp_7_organoleticos, obj_tabela_editar?.camp_8_organoleticos),
            total_nutritivos: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_nutritivos, obj_tabela_editar?.camp_2_nutritivos, obj_tabela_editar?.camp_3_nutritivos, obj_tabela_editar?.camp_4_nutritivos,
              obj_tabela_editar?.camp_5_nutritivos, obj_tabela_editar?.camp_6_nutritivos, obj_tabela_editar?.camp_7_nutritivos, obj_tabela_editar?.camp_8_nutritivos),
            total_ambientais: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_ambientais, obj_tabela_editar?.camp_2_ambientais, obj_tabela_editar?.camp_3_ambientais, obj_tabela_editar?.camp_4_ambientais,
              obj_tabela_editar?.camp_5_ambientais, obj_tabela_editar?.camp_6_ambientais, obj_tabela_editar?.camp_7_ambientais, obj_tabela_editar?.camp_8_ambientais),
            total_melhorados: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_melhoradores_digestinais, obj_tabela_editar?.camp_2_melhoradores_digestinais, obj_tabela_editar?.camp_3_melhoradores_digestinais, obj_tabela_editar?.camp_4_melhoradores_digestinais,
              obj_tabela_editar?.camp_5_melhoradores_digestinais, obj_tabela_editar?.camp_6_melhoradores_digestinais, obj_tabela_editar?.camp_7_melhoradores_digestinais, obj_tabela_editar?.camp_8_melhoradores_digestinais),
            total_estabilizadores: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_estabilizadores_floragastrica, obj_tabela_editar?.camp_2_estabilizadores_floragastrica, obj_tabela_editar?.camp_3_estabilizadores_floragastrica, obj_tabela_editar?.camp_4_estabilizadores_floragastrica,
              obj_tabela_editar?.camp_5_estabilizadores_floragastrica, obj_tabela_editar?.camp_6_estabilizadores_floragastrica, obj_tabela_editar?.camp_7_estabilizadores_floragastrica, obj_tabela_editar?.camp_8_estabilizadores_floragastrica),
            total_otros_zoote: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_outros_zootecnicos, obj_tabela_editar?.camp_2_outros_zootecnicos, obj_tabela_editar?.camp_3_outros_zootecnicos, obj_tabela_editar?.camp_4_outros_zootecnicos,
              obj_tabela_editar?.camp_5_outros_zootecnicos, obj_tabela_editar?.camp_6_outros_zootecnicos, obj_tabela_editar?.camp_7_outros_zootecnicos, obj_tabela_editar?.camp_8_outros_zootecnicos),
            id_grupo: especie_ou_lote_homegenio_selecionada?.id_grupo,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          setTabela(res.data.result[0]);
          set_necessidades_dia(res.data.result[1][0]);


          set_obj_tabela_editar(undefined);
          setCreate(false);
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveTabela", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
  }

  const handleEdit = (obj: IAlimento | undefined) => {
    set_obj_tabela_editar(obj);
    setEditRow(true);
  };

  const handleUpdatetabela = async () => {
    if (obj_tabela_editar === undefined) {
      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, `update_alimento_composto_GH`, {
        payload: {
          id_alimento: obj_tabela_editar.id_alimento,
          camp_1_proteina_bruta: obj_tabela_editar.camp_1_proteina_bruta === undefined || obj_tabela_editar?.camp_1_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_1_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_1_proteina_bruta),
          camp_2_proteina_bruta: obj_tabela_editar.camp_2_proteina_bruta === undefined || obj_tabela_editar?.camp_2_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_2_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_2_proteina_bruta),
          camp_3_proteina_bruta: obj_tabela_editar.camp_3_proteina_bruta === undefined || obj_tabela_editar?.camp_3_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_3_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_3_proteina_bruta),
          camp_4_proteina_bruta: obj_tabela_editar.camp_4_proteina_bruta === undefined || obj_tabela_editar?.camp_4_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_4_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_4_proteina_bruta),
          camp_5_proteina_bruta: obj_tabela_editar.camp_5_proteina_bruta === undefined || obj_tabela_editar?.camp_5_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_5_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_5_proteina_bruta),
          camp_6_proteina_bruta: obj_tabela_editar.camp_6_proteina_bruta === undefined || obj_tabela_editar?.camp_6_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_6_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_6_proteina_bruta),
          camp_7_proteina_bruta: obj_tabela_editar.camp_7_proteina_bruta === undefined || obj_tabela_editar?.camp_7_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_7_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_7_proteina_bruta),
          camp_8_proteina_bruta: obj_tabela_editar.camp_8_proteina_bruta === undefined || obj_tabela_editar?.camp_8_proteina_bruta === null ? 0 : obj_tabela_editar?.camp_8_proteina_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_8_proteina_bruta),
          camp_1_gordura_bruta: obj_tabela_editar.camp_1_gordura_bruta === undefined || obj_tabela_editar?.camp_1_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_1_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_1_gordura_bruta),
          camp_2_gordura_bruta: obj_tabela_editar.camp_2_gordura_bruta === undefined || obj_tabela_editar?.camp_2_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_2_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_2_gordura_bruta),
          camp_3_gordura_bruta: obj_tabela_editar.camp_3_gordura_bruta === undefined || obj_tabela_editar?.camp_3_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_3_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_3_gordura_bruta),
          camp_4_gordura_bruta: obj_tabela_editar.camp_4_gordura_bruta === undefined || obj_tabela_editar?.camp_4_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_4_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_4_gordura_bruta),
          camp_5_gordura_bruta: obj_tabela_editar.camp_5_gordura_bruta === undefined || obj_tabela_editar?.camp_5_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_5_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_5_gordura_bruta),
          camp_6_gordura_bruta: obj_tabela_editar.camp_6_gordura_bruta === undefined || obj_tabela_editar?.camp_6_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_6_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_6_gordura_bruta),
          camp_7_gordura_bruta: obj_tabela_editar.camp_7_gordura_bruta === undefined || obj_tabela_editar?.camp_7_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_7_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_7_gordura_bruta),
          camp_8_gordura_bruta: obj_tabela_editar.camp_8_gordura_bruta === undefined || obj_tabela_editar?.camp_8_gordura_bruta === null ? 0 : obj_tabela_editar?.camp_8_gordura_bruta.toString().length === 0 ? 0 : (obj_tabela_editar.camp_8_gordura_bruta),
          camp_1_organoleticos: obj_tabela_editar.camp_1_organoleticos === undefined ? "" : (obj_tabela_editar.camp_1_organoleticos),
          camp_2_organoleticos: obj_tabela_editar.camp_2_organoleticos === undefined ? "" : (obj_tabela_editar.camp_2_organoleticos),
          camp_3_organoleticos: obj_tabela_editar.camp_3_organoleticos === undefined ? "" : (obj_tabela_editar.camp_3_organoleticos),
          camp_4_organoleticos: obj_tabela_editar.camp_4_organoleticos === undefined ? "" : (obj_tabela_editar.camp_4_organoleticos),
          camp_5_organoleticos: obj_tabela_editar.camp_5_organoleticos === undefined ? "" : (obj_tabela_editar.camp_5_organoleticos),
          camp_6_organoleticos: obj_tabela_editar.camp_6_organoleticos === undefined ? "" : (obj_tabela_editar.camp_6_organoleticos),
          camp_7_organoleticos: obj_tabela_editar.camp_7_organoleticos === undefined ? "" : (obj_tabela_editar.camp_7_organoleticos),
          camp_8_organoleticos: obj_tabela_editar.camp_8_organoleticos === undefined ? "" : (obj_tabela_editar.camp_8_organoleticos),
          camp_1_nutritivos: obj_tabela_editar.camp_1_nutritivos === undefined ? "" : (obj_tabela_editar.camp_1_nutritivos),
          camp_2_nutritivos: obj_tabela_editar.camp_2_nutritivos === undefined ? "" : (obj_tabela_editar.camp_2_nutritivos),
          camp_3_nutritivos: obj_tabela_editar.camp_3_nutritivos === undefined ? "" : (obj_tabela_editar.camp_3_nutritivos),
          camp_4_nutritivos: obj_tabela_editar.camp_4_nutritivos === undefined ? "" : (obj_tabela_editar.camp_4_nutritivos),
          camp_5_nutritivos: obj_tabela_editar.camp_5_nutritivos === undefined ? "" : (obj_tabela_editar.camp_5_nutritivos),
          camp_6_nutritivos: obj_tabela_editar.camp_6_nutritivos === undefined ? "" : (obj_tabela_editar.camp_6_nutritivos),
          camp_7_nutritivos: obj_tabela_editar.camp_7_nutritivos === undefined ? "" : (obj_tabela_editar.camp_7_nutritivos),
          camp_8_nutritivos: obj_tabela_editar.camp_8_nutritivos === undefined ? "" : (obj_tabela_editar.camp_8_nutritivos),
          camp_1_ambientais: obj_tabela_editar.camp_1_ambientais === undefined ? "" : (obj_tabela_editar.camp_1_ambientais),
          camp_2_ambientais: obj_tabela_editar.camp_2_ambientais === undefined ? "" : (obj_tabela_editar.camp_2_ambientais),
          camp_3_ambientais: obj_tabela_editar.camp_3_ambientais === undefined ? "" : (obj_tabela_editar.camp_3_ambientais),
          camp_4_ambientais: obj_tabela_editar.camp_4_ambientais === undefined ? "" : (obj_tabela_editar.camp_4_ambientais),
          camp_5_ambientais: obj_tabela_editar.camp_5_ambientais === undefined ? "" : (obj_tabela_editar.camp_5_ambientais),
          camp_6_ambientais: obj_tabela_editar.camp_6_ambientais === undefined ? "" : (obj_tabela_editar.camp_6_ambientais),
          camp_7_ambientais: obj_tabela_editar.camp_7_ambientais === undefined ? "" : (obj_tabela_editar.camp_7_ambientais),
          camp_8_ambientais: obj_tabela_editar.camp_8_ambientais === undefined ? "" : (obj_tabela_editar.camp_8_ambientais),
          camp_1_melhoradores_digestinais: obj_tabela_editar.camp_1_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_1_melhoradores_digestinais),
          camp_2_melhoradores_digestinais: obj_tabela_editar.camp_2_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_2_melhoradores_digestinais),
          camp_3_melhoradores_digestinais: obj_tabela_editar.camp_3_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_3_melhoradores_digestinais),
          camp_4_melhoradores_digestinais: obj_tabela_editar.camp_4_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_4_melhoradores_digestinais),
          camp_5_melhoradores_digestinais: obj_tabela_editar.camp_5_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_5_melhoradores_digestinais),
          camp_6_melhoradores_digestinais: obj_tabela_editar.camp_6_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_6_melhoradores_digestinais),
          camp_7_melhoradores_digestinais: obj_tabela_editar.camp_7_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_7_melhoradores_digestinais),
          camp_8_melhoradores_digestinais: obj_tabela_editar.camp_8_melhoradores_digestinais === undefined ? "" : (obj_tabela_editar.camp_8_melhoradores_digestinais),
          camp_1_estabilizadores_floragastrica: obj_tabela_editar.camp_1_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_1_estabilizadores_floragastrica),
          camp_2_estabilizadores_floragastrica: obj_tabela_editar.camp_2_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_2_estabilizadores_floragastrica),
          camp_3_estabilizadores_floragastrica: obj_tabela_editar.camp_3_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_3_estabilizadores_floragastrica),
          camp_4_estabilizadores_floragastrica: obj_tabela_editar.camp_4_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_4_estabilizadores_floragastrica),
          camp_5_estabilizadores_floragastrica: obj_tabela_editar.camp_5_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_5_estabilizadores_floragastrica),
          camp_6_estabilizadores_floragastrica: obj_tabela_editar.camp_6_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_6_estabilizadores_floragastrica),
          camp_7_estabilizadores_floragastrica: obj_tabela_editar.camp_7_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_7_estabilizadores_floragastrica),
          camp_8_estabilizadores_floragastrica: obj_tabela_editar.camp_8_estabilizadores_floragastrica === undefined ? "" : (obj_tabela_editar.camp_8_estabilizadores_floragastrica),
          camp_1_outros_zootecnicos: obj_tabela_editar.camp_1_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_1_outros_zootecnicos),
          camp_2_outros_zootecnicos: obj_tabela_editar.camp_2_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_2_outros_zootecnicos),
          camp_3_outros_zootecnicos: obj_tabela_editar.camp_3_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_3_outros_zootecnicos),
          camp_4_outros_zootecnicos: obj_tabela_editar.camp_4_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_4_outros_zootecnicos),
          camp_5_outros_zootecnicos: obj_tabela_editar.camp_5_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_5_outros_zootecnicos),
          camp_6_outros_zootecnicos: obj_tabela_editar.camp_6_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_6_outros_zootecnicos),
          camp_7_outros_zootecnicos: obj_tabela_editar.camp_7_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_7_outros_zootecnicos),
          camp_8_outros_zootecnicos: obj_tabela_editar.camp_8_outros_zootecnicos === undefined ? "" : (obj_tabela_editar.camp_8_outros_zootecnicos),
          camp_1_fosforo_total: obj_tabela_editar.camp_1_fosforo_total === undefined || obj_tabela_editar?.camp_1_fosforo_total === null ? 0 : obj_tabela_editar?.camp_1_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_1_fosforo_total),
          camp_2_fosforo_total: obj_tabela_editar.camp_2_fosforo_total === undefined || obj_tabela_editar?.camp_2_fosforo_total === null ? 0 : obj_tabela_editar?.camp_2_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_2_fosforo_total),
          camp_3_fosforo_total: obj_tabela_editar.camp_3_fosforo_total === undefined || obj_tabela_editar?.camp_3_fosforo_total === null ? 0 : obj_tabela_editar?.camp_3_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_3_fosforo_total),
          camp_4_fosforo_total: obj_tabela_editar.camp_4_fosforo_total === undefined || obj_tabela_editar?.camp_4_fosforo_total === null ? 0 : obj_tabela_editar?.camp_4_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_4_fosforo_total),
          camp_5_fosforo_total: obj_tabela_editar.camp_5_fosforo_total === undefined || obj_tabela_editar?.camp_5_fosforo_total === null ? 0 : obj_tabela_editar?.camp_5_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_5_fosforo_total),
          camp_6_fosforo_total: obj_tabela_editar.camp_6_fosforo_total === undefined || obj_tabela_editar?.camp_6_fosforo_total === null ? 0 : obj_tabela_editar?.camp_6_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_6_fosforo_total),
          camp_7_fosforo_total: obj_tabela_editar.camp_7_fosforo_total === undefined || obj_tabela_editar?.camp_7_fosforo_total === null ? 0 : obj_tabela_editar?.camp_7_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_7_fosforo_total),
          camp_8_fosforo_total: obj_tabela_editar.camp_8_fosforo_total === undefined || obj_tabela_editar?.camp_8_fosforo_total === null ? 0 : obj_tabela_editar?.camp_8_fosforo_total.toString().length === 0 ? 0 : (obj_tabela_editar.camp_8_fosforo_total),
          total_bovinos_maior: total_proteina_bruta_maior_ou_igual_6(alimento_composto_total, alimento_composto_1, alimento_composto_2, obj_tabela_editar?.camp_3_proteina_bruta, alimento_composto_3, obj_tabela_editar?.camp_4_proteina_bruta, alimento_composto_4, obj_tabela_editar?.camp_5_proteina_bruta, alimento_composto_5, obj_tabela_editar?.camp_6_proteina_bruta, alimento_composto_6, obj_tabela_editar?.camp_7_proteina_bruta, alimento_composto_7, obj_tabela_editar?.camp_8_proteina_bruta, alimento_composto_8),
          total_bovinos_menor: total_proteina_bruta_menor_6(obj_tabela_editar?.camp_1_proteina_bruta, alimento_composto_1, obj_tabela_editar?.camp_2_proteina_bruta, alimento_composto_2),
          total_fosforo: total_fosforo_total(alimento_composto_total, obj_tabela_editar?.camp_1_fosforo_total, alimento_composto_1, obj_tabela_editar?.camp_2_fosforo_total, alimento_composto_2, obj_tabela_editar?.camp_1_fosforo_total, alimento_composto_3, obj_tabela_editar?.camp_4_fosforo_total, alimento_composto_4, obj_tabela_editar?.camp_5_fosforo_total, alimento_composto_5, obj_tabela_editar?.camp_6_fosforo_total, alimento_composto_6, obj_tabela_editar?.camp_7_fosforo_total, alimento_composto_7, obj_tabela_editar?.camp_8_fosforo_total, alimento_composto_8),
          total_gordura: total_gordura_bruta(alimento_composto_total, obj_tabela_editar?.camp_1_gordura_bruta, alimento_composto_1, obj_tabela_editar?.camp_2_gordura_bruta, alimento_composto_2, obj_tabela_editar?.camp_1_gordura_bruta, alimento_composto_3, obj_tabela_editar?.camp_4_gordura_bruta, alimento_composto_4, obj_tabela_editar?.camp_5_gordura_bruta, alimento_composto_5, obj_tabela_editar?.camp_6_gordura_bruta, alimento_composto_6, obj_tabela_editar?.camp_7_gordura_bruta, alimento_composto_7, obj_tabela_editar?.camp_8_gordura_bruta, alimento_composto_8),
          total_organoleticos: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_organoleticos, obj_tabela_editar?.camp_2_organoleticos, obj_tabela_editar?.camp_3_organoleticos, obj_tabela_editar?.camp_4_organoleticos,
            obj_tabela_editar?.camp_5_organoleticos, obj_tabela_editar?.camp_6_organoleticos, obj_tabela_editar?.camp_7_organoleticos, obj_tabela_editar?.camp_8_organoleticos),
          total_nutritivos: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_nutritivos, obj_tabela_editar?.camp_2_nutritivos, obj_tabela_editar?.camp_3_nutritivos, obj_tabela_editar?.camp_4_nutritivos,
            obj_tabela_editar?.camp_5_nutritivos, obj_tabela_editar?.camp_6_nutritivos, obj_tabela_editar?.camp_7_nutritivos, obj_tabela_editar?.camp_8_nutritivos),
          total_ambientais: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_ambientais, obj_tabela_editar?.camp_2_ambientais, obj_tabela_editar?.camp_3_ambientais, obj_tabela_editar?.camp_4_ambientais,
            obj_tabela_editar?.camp_5_ambientais, obj_tabela_editar?.camp_6_ambientais, obj_tabela_editar?.camp_7_ambientais, obj_tabela_editar?.camp_8_ambientais),
          total_melhorados: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_melhoradores_digestinais, obj_tabela_editar?.camp_2_melhoradores_digestinais, obj_tabela_editar?.camp_3_melhoradores_digestinais, obj_tabela_editar?.camp_4_melhoradores_digestinais,
            obj_tabela_editar?.camp_5_melhoradores_digestinais, obj_tabela_editar?.camp_6_melhoradores_digestinais, obj_tabela_editar?.camp_7_melhoradores_digestinais, obj_tabela_editar?.camp_8_melhoradores_digestinais),
          total_estabilizadores: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_estabilizadores_floragastrica, obj_tabela_editar?.camp_2_estabilizadores_floragastrica, obj_tabela_editar?.camp_3_estabilizadores_floragastrica, obj_tabela_editar?.camp_4_estabilizadores_floragastrica,
            obj_tabela_editar?.camp_5_estabilizadores_floragastrica, obj_tabela_editar?.camp_6_estabilizadores_floragastrica, obj_tabela_editar?.camp_7_estabilizadores_floragastrica, obj_tabela_editar?.camp_8_estabilizadores_floragastrica),
          total_otros_zoote: contabilizar_x_e_valores_numericos(obj_tabela_editar?.camp_1_outros_zootecnicos, obj_tabela_editar?.camp_2_outros_zootecnicos, obj_tabela_editar?.camp_3_outros_zootecnicos, obj_tabela_editar?.camp_4_outros_zootecnicos,
            obj_tabela_editar?.camp_5_outros_zootecnicos, obj_tabela_editar?.camp_6_outros_zootecnicos, obj_tabela_editar?.camp_7_outros_zootecnicos, obj_tabela_editar?.camp_8_outros_zootecnicos),
          id_grupo: especie_ou_lote_homegenio_selecionada?.id_grupo,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        setTabela(res.data.result[0]);
        set_necessidades_dia(res.data.result[1][0]);
        set_obj_tabela_editar(undefined);
        setEditRow(false);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdatetabela", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  // DELETE
  const handleClickOpenDelete = (id: number | null | undefined) => {
    setIdToDelete(id);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      if (idToDelete !== null) {
        setIsLoading(true);

        let res = await del(auth.token.cookie_token, `/delete_alimento_composto_GH/${idToDelete}`);

        if (res.status === 200) {
          setMessage("Registo eliminado com sucesso!");
          setOpenDelete(false);
          set_necessidades_dia(res.data.result[0]);

          setTabela(undefined)
          setIdToDelete(null);
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ?
        <LoadingVulpes /> :
        <>
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{
              height: "auto",
              width: "auto",
              margin: 2,
              padding: 2,
            }}
          >
            <Snackbar
              open={openSnackSuccess}
              autoHideDuration={2000}
              onClose={() => setOpenSnackSuccess(false)}
            >
              <Alert
                onClose={() => setOpenSnackSuccess(false)}
                severity="success"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSnackError}
              autoHideDuration={2000}
              onClose={() => setOpenSnackError(false)}
            >
              <Alert
                onClose={() => setOpenSnackError(false)}
                severity="error"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <table style={{ width: "75%" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={9}
                    sx={{
                      fontWeight: 700,
                      fontSize: 16,
                      fontFamily: "candara",
                    }}
                  >
                    4. Alimento Composto
                  </TableCell>
                  {tabela === undefined && create === false && editRow === false ?
                    <TableCell >
                      <Box sx={{ display: "flex", justifyContent: "end" }}>
                        <BarraDeFerramentas
                          mostrarBotaoNovo
                          textoBotaoNovo="Novo Registo"
                          aoClicarNovo={() => setCreate(true)}
                        />
                      </Box>
                    </TableCell>
                    :
                    tabela !== undefined && create === false && editRow === false ?
                      <TableCell
                        colSpan={8}
                        sx={{ alignItems: "center", justifyContent: "end" }}
                      >
                        <ButtonCadernos
                          mostrarBotaoEditar
                          aoClicarEditar={() => handleEdit(tabela)}
                          mostrarBotaoApagar
                          aoClicarApagar={() => handleClickOpenDelete(tabela?.id_alimento)}
                        />
                      </TableCell>
                      :
                      <TableCell>
                        <Box sx={{ display: "flex", justifyContent: "end" }}>
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={handleCancel}
                            mostrarBotaoGravar
                            aoClicarGravar={() => handleSave()}
                          />
                        </Box>
                      </TableCell>
                  }
                </TableRow>
                <TableRow>
                  <StyledTableHead rowSpan={4}>Efetivo Pecuário</StyledTableHead>
                  <StyledTableHead colSpan={9}>Alimento Composto</StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableHead rowSpan={3}> Proteína Bruta (g/kgMS)</StyledTableHead>
                  <StyledTableHead rowSpan={3}> Gordura Bruta (g/kgMS)</StyledTableHead>
                  <StyledTableHead colSpan={6}>Aditivos
                    <BasicPopover text={'Se constantes no alimento composto, assinalar com "x".'} />
                  </StyledTableHead>
                  <StyledTableHead rowSpan={3}> Fósforo Total (g/kgMS)</StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableHead rowSpan={2}>Organoléticos</StyledTableHead>
                  <StyledTableHead rowSpan={2}>Nutritivos</StyledTableHead>
                  <StyledTableHead colSpan={4}>Zootécnicos</StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableHead>Ambientais</StyledTableHead>
                  <StyledTableHead>Melhoradores digestibilidade</StyledTableHead>
                  <StyledTableHead>Estabilizadores  flora gástrica</StyledTableHead>
                  <StyledTableHead>Outros zootécnicos</StyledTableHead>
                </TableRow>
              </TableHead>
              <TableBody>
                {create === true || editRow === true ?
                  <>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Machos com < 6 Meses"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_proteina_bruta"
                          value={obj_tabela_editar?.camp_1_proteina_bruta != null ? obj_tabela_editar?.camp_1_proteina_bruta.toString().replace('.', ',') : ""}
                          onChange={onInputChange}
                          error={error_camp_1_proteina_bruta}
                          helperText={error_camp_1_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_gordura_bruta"
                          value={obj_tabela_editar?.camp_1_gordura_bruta != null ? obj_tabela_editar?.camp_1_gordura_bruta.toString().replace('.', ',') : ""}
                          onChange={onInputChange}
                          error={error_camp_1_gordura_bruta}
                          helperText={error_camp_1_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_organoleticos"
                          value={obj_tabela_editar?.camp_1_organoleticos != null ? obj_tabela_editar?.camp_1_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_1_organoleticos}
                          helperText={error_camp_1_organoleticos ? message_apenas_x : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_nutritivos"
                          value={obj_tabela_editar?.camp_1_nutritivos != null ? obj_tabela_editar?.camp_1_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_1_nutritivos}
                          helperText={error_camp_1_nutritivos ? message_apenas_x : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_ambientais"
                          value={obj_tabela_editar?.camp_1_ambientais != null ? obj_tabela_editar?.camp_1_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_1_ambientais}
                          helperText={error_camp_1_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_1_melhoradores_digestinais != null ? obj_tabela_editar?.camp_1_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_1_melhoradores}
                          helperText={error_camp_1_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_1_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_1_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_1_estabilizadores}
                          helperText={error_camp_1_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_1_outros_zootecnicos != null ? obj_tabela_editar?.camp_1_outros_zootecnicos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_1_zootecnicos}
                          helperText={error_camp_1_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_1_fosforo_total"
                          value={obj_tabela_editar?.camp_1_fosforo_total != null ? obj_tabela_editar?.camp_1_fosforo_total.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_1_fosforo_total}
                          helperText={error_camp_1_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Fêmeas com < 6 Meses"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_proteina_bruta"
                          value={obj_tabela_editar?.camp_2_proteina_bruta != null ? obj_tabela_editar?.camp_2_proteina_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_proteina_bruta}
                          helperText={error_camp_2_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_gordura_bruta"
                          value={obj_tabela_editar?.camp_2_gordura_bruta != null ? obj_tabela_editar?.camp_2_gordura_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_gordura_bruta}
                          helperText={error_camp_2_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_organoleticos"
                          value={obj_tabela_editar?.camp_2_organoleticos != null ? obj_tabela_editar?.camp_2_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_organoleticos}
                          helperText={error_camp_2_organoleticos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_nutritivos"
                          value={obj_tabela_editar?.camp_2_nutritivos != null ? obj_tabela_editar?.camp_2_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_nutritivos}
                          helperText={error_camp_2_nutritivos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_ambientais"
                          value={obj_tabela_editar?.camp_2_ambientais != null ? obj_tabela_editar?.camp_2_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_ambientais}
                          helperText={error_camp_2_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_2_melhoradores_digestinais != null ? obj_tabela_editar?.camp_2_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_melhoradores}
                          helperText={error_camp_2_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_2_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_2_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_estabilizadores}
                          helperText={error_camp_2_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_2_outros_zootecnicos != null ? obj_tabela_editar?.camp_2_outros_zootecnicos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_zootecnicos}
                          helperText={error_camp_2_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_2_fosforo_total"
                          value={obj_tabela_editar?.camp_2_fosforo_total != null ? obj_tabela_editar?.camp_2_fosforo_total.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_2_fosforo_total}
                          helperText={error_camp_2_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Machos de 6 meses a < 1 ano"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_proteina_bruta"
                          value={obj_tabela_editar?.camp_3_proteina_bruta != null ? obj_tabela_editar?.camp_3_proteina_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_proteina_bruta}
                          helperText={error_camp_3_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_gordura_bruta"
                          value={obj_tabela_editar?.camp_3_gordura_bruta != null ? obj_tabela_editar?.camp_3_gordura_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_gordura_bruta}
                          helperText={error_camp_3_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_organoleticos"
                          value={obj_tabela_editar?.camp_3_organoleticos != null ? obj_tabela_editar?.camp_3_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_organoleticos}
                          helperText={error_camp_3_organoleticos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_nutritivos"
                          value={obj_tabela_editar?.camp_3_nutritivos != null ? obj_tabela_editar?.camp_3_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_nutritivos}
                          helperText={error_camp_3_nutritivos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_ambientais"
                          value={obj_tabela_editar?.camp_3_ambientais != null ? obj_tabela_editar?.camp_3_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_ambientais}
                          helperText={error_camp_3_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_3_melhoradores_digestinais != null ? obj_tabela_editar?.camp_3_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_melhoradores}
                          helperText={error_camp_3_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_3_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_3_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_estabilizadores}
                          helperText={error_camp_3_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_3_outros_zootecnicos != null ? obj_tabela_editar?.camp_3_outros_zootecnicos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_zootecnicos}
                          helperText={error_camp_3_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_3_fosforo_total"
                          value={obj_tabela_editar?.camp_3_fosforo_total != null ? obj_tabela_editar?.camp_3_fosforo_total.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_3_fosforo_total}
                          helperText={error_camp_3_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Fêmeas de 6 meses a < 1 ano"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_proteina_bruta"
                          value={obj_tabela_editar?.camp_4_proteina_bruta != null ? obj_tabela_editar?.camp_4_proteina_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_proteina_bruta}
                          helperText={error_camp_4_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_gordura_bruta"
                          value={obj_tabela_editar?.camp_4_gordura_bruta != null ? obj_tabela_editar?.camp_4_gordura_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_gordura_bruta}
                          helperText={error_camp_4_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_organoleticos"
                          value={obj_tabela_editar?.camp_4_organoleticos != null ? obj_tabela_editar?.camp_4_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_organoleticos}
                          helperText={error_camp_4_organoleticos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_nutritivos"
                          value={obj_tabela_editar?.camp_4_nutritivos != null ? obj_tabela_editar?.camp_4_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_nutritivos}
                          helperText={error_camp_4_nutritivos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_ambientais"
                          value={obj_tabela_editar?.camp_4_ambientais != null ? obj_tabela_editar?.camp_4_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_ambientais}
                          helperText={error_camp_4_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_4_melhoradores_digestinais != null ? obj_tabela_editar?.camp_4_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_melhoradores}
                          helperText={error_camp_4_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_4_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_4_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_estabilizadores}
                          helperText={error_camp_4_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_4_outros_zootecnicos != null ? obj_tabela_editar?.camp_4_outros_zootecnicos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_zootecnicos}
                          helperText={error_camp_4_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_4_fosforo_total"
                          value={obj_tabela_editar?.camp_4_fosforo_total != null ? obj_tabela_editar?.camp_4_fosforo_total.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_4_fosforo_total}
                          helperText={error_camp_4_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Machos de 1 ano a < 2 anos"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_proteina_bruta"
                          value={obj_tabela_editar?.camp_5_proteina_bruta != null ? obj_tabela_editar?.camp_5_proteina_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_proteina_bruta}
                          helperText={error_camp_5_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_gordura_bruta"
                          value={obj_tabela_editar?.camp_5_gordura_bruta != null ? obj_tabela_editar?.camp_5_gordura_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_gordura_bruta}
                          helperText={error_camp_5_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_organoleticos"
                          value={obj_tabela_editar?.camp_5_organoleticos != null ? obj_tabela_editar?.camp_5_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_organoleticos}
                          helperText={error_camp_5_organoleticos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_nutritivos"
                          value={obj_tabela_editar?.camp_5_nutritivos != null ? obj_tabela_editar?.camp_5_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_nutritivos}
                          helperText={error_camp_5_nutritivos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_ambientais"
                          value={obj_tabela_editar?.camp_5_ambientais != null ? obj_tabela_editar?.camp_5_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_ambientais}
                          helperText={error_camp_5_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_5_melhoradores_digestinais != null ? obj_tabela_editar?.camp_5_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_melhoradores}
                          helperText={error_camp_5_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_5_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_5_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_estabilizadores}
                          helperText={error_camp_5_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_5_outros_zootecnicos != null ? obj_tabela_editar?.camp_5_outros_zootecnicos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_zootecnicos}
                          helperText={error_camp_5_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_5_fosforo_total"
                          value={obj_tabela_editar?.camp_5_fosforo_total != null ? obj_tabela_editar?.camp_5_fosforo_total.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_5_fosforo_total}
                          helperText={error_camp_5_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Fêmeas de 1 ano a < 2 anos"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_proteina_bruta"
                          value={obj_tabela_editar?.camp_6_proteina_bruta != null ? obj_tabela_editar?.camp_6_proteina_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_proteina_bruta}
                          helperText={error_camp_6_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_gordura_bruta"
                          value={obj_tabela_editar?.camp_6_gordura_bruta != null ? obj_tabela_editar?.camp_6_gordura_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_gordura_bruta}
                          helperText={error_camp_6_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_organoleticos"
                          value={obj_tabela_editar?.camp_6_organoleticos != null ? obj_tabela_editar?.camp_6_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_organoleticos}
                          helperText={error_camp_6_organoleticos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_nutritivos"
                          value={obj_tabela_editar?.camp_6_nutritivos != null ? obj_tabela_editar?.camp_6_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_nutritivos}
                          helperText={error_camp_6_nutritivos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_ambientais"
                          value={obj_tabela_editar?.camp_6_ambientais != null ? obj_tabela_editar?.camp_6_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_ambientais}
                          helperText={error_camp_6_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_6_melhoradores_digestinais != null ? obj_tabela_editar?.camp_6_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_melhoradores}
                          helperText={error_camp_6_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_6_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_6_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_estabilizadores}
                          helperText={error_camp_6_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_6_outros_zootecnicos != null ? obj_tabela_editar?.camp_6_outros_zootecnicos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_zootecnicos}
                          helperText={error_camp_6_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_6_fosforo_total"
                          value={obj_tabela_editar?.camp_6_fosforo_total != null ? obj_tabela_editar?.camp_6_fosforo_total.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_6_fosforo_total}
                          helperText={error_camp_6_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Machos com ≥ 2 anos"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_proteina_bruta"
                          value={obj_tabela_editar?.camp_7_proteina_bruta != null ? obj_tabela_editar?.camp_7_proteina_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_proteina_bruta}
                          helperText={error_camp_7_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_gordura_bruta"
                          value={obj_tabela_editar?.camp_7_gordura_bruta != null ? obj_tabela_editar?.camp_7_gordura_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_gordura_bruta}
                          helperText={error_camp_7_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_organoleticos"
                          value={obj_tabela_editar?.camp_7_organoleticos != null ? obj_tabela_editar?.camp_7_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_organoleticos}
                          helperText={error_camp_7_organoleticos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_nutritivos"
                          value={obj_tabela_editar?.camp_7_nutritivos != null ? obj_tabela_editar?.camp_7_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_nutritivos}
                          helperText={error_camp_7_nutritivos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_ambientais"
                          value={obj_tabela_editar?.camp_7_ambientais != null ? obj_tabela_editar?.camp_7_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_ambientais}
                          helperText={error_camp_7_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_7_melhoradores_digestinais != null ? obj_tabela_editar?.camp_7_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_melhoradores}
                          helperText={error_camp_7_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_7_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_7_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_estabilizadores}
                          helperText={error_camp_7_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_7_outros_zootecnicos != null ? obj_tabela_editar?.camp_7_outros_zootecnicos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_zootecnicos}
                          helperText={error_camp_7_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_7_fosforo_total"
                          value={obj_tabela_editar?.camp_7_fosforo_total != null ? obj_tabela_editar?.camp_7_fosforo_total.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_7_fosforo_total}
                          helperText={error_camp_7_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        {"Bovinos Fêmeas com ≥ 2 anos"}
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_proteina_bruta"
                          value={obj_tabela_editar?.camp_8_proteina_bruta != null ? obj_tabela_editar?.camp_8_proteina_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_8_proteina_bruta}
                          helperText={error_camp_8_proteina_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_gordura_bruta"
                          value={obj_tabela_editar?.camp_8_gordura_bruta != null ? obj_tabela_editar?.camp_8_gordura_bruta.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_8_gordura_bruta}
                          helperText={error_camp_8_gordura_bruta ? message_apenas_numero : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_organoleticos"
                          value={obj_tabela_editar?.camp_8_organoleticos != null ? obj_tabela_editar?.camp_8_organoleticos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_8_organoleticos}
                          helperText={error_camp_8_organoleticos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_nutritivos"
                          value={obj_tabela_editar?.camp_8_nutritivos != null ? obj_tabela_editar?.camp_8_nutritivos.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_8_nutritivos}
                          helperText={error_camp_8_nutritivos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_ambientais"
                          value={obj_tabela_editar?.camp_8_ambientais != null ? obj_tabela_editar?.camp_8_ambientais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_8_ambientais}
                          helperText={error_camp_8_ambientais ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_melhoradores_digestinais"
                          value={obj_tabela_editar?.camp_8_melhoradores_digestinais != null ? obj_tabela_editar?.camp_8_melhoradores_digestinais.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_8_melhoradores}
                          helperText={error_camp_8_melhoradores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_estabilizadores_floragastrica"
                          value={obj_tabela_editar?.camp_8_estabilizadores_floragastrica != null ? obj_tabela_editar?.camp_8_estabilizadores_floragastrica.toString().replace('.', ',') : ""}

                          onChange={onInputChange}
                          error={error_camp_8_estabilizadores}
                          helperText={error_camp_8_estabilizadores ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_outros_zootecnicos"
                          value={obj_tabela_editar?.camp_8_outros_zootecnicos != null ? obj_tabela_editar?.camp_8_outros_zootecnicos.toString().replace('.', ',') : ""}
                          onChange={onInputChange}
                          error={error_camp_8_zootecnicos}
                          helperText={error_camp_8_zootecnicos ? message_apenas_x : ""} />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="camp_8_fosforo_total"
                          value={obj_tabela_editar?.camp_8_fosforo_total != null ? obj_tabela_editar?.camp_8_fosforo_total.toString().replace('.', ',') : ""}
                          onChange={onInputChange}
                          error={error_camp_8_fosforo_total}
                          helperText={error_camp_8_fosforo_total ? message_apenas_numero : ""} />
                      </StyledTableCell>
                    </TableRow>
                  </>
                  :
                  <>
                    <TableRow>
                      <StyledTableHead>{"Bovinos Machos com < 6 Meses"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_1_proteina_bruta === null || tabela?.camp_1_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_1_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_gordura_bruta === null || tabela?.camp_1_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_1_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_organoleticos === undefined ? '' : tabela?.camp_1_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_nutritivos === undefined ? '' : tabela?.camp_1_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_ambientais === undefined ? '' : tabela?.camp_1_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_melhoradores_digestinais === undefined ? '' : tabela?.camp_1_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_1_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_outros_zootecnicos === undefined ? '' : (tabela?.camp_1_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_1_fosforo_total === null || tabela?.camp_1_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_1_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>{"Bovinos Fêmeas com < 6 Meses"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_2_proteina_bruta === null || tabela?.camp_2_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_2_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_gordura_bruta === null || tabela?.camp_2_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_2_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_organoleticos === undefined ? '' : tabela?.camp_2_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_nutritivos === undefined ? '' : tabela?.camp_2_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_ambientais === undefined ? '' : tabela?.camp_2_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_melhoradores_digestinais === undefined ? '' : tabela?.camp_2_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_2_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_outros_zootecnicos === undefined ? '' : (tabela?.camp_2_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_2_fosforo_total === null || tabela?.camp_2_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_2_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>{"Bovinos Machos de 6 Meses a < 1 ano"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_3_proteina_bruta === null || tabela?.camp_3_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_3_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_gordura_bruta === null || tabela?.camp_3_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_3_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_organoleticos === undefined ? '' : tabela?.camp_3_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_nutritivos === undefined ? '' : tabela?.camp_3_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_ambientais === undefined ? '' : tabela?.camp_3_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_melhoradores_digestinais === undefined ? '' : tabela?.camp_3_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_3_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_outros_zootecnicos === undefined ? '' : (tabela?.camp_3_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_3_fosforo_total === null || tabela?.camp_3_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_3_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>{"Bovinos Fêmeas de 6 Meses a < 1 ano"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_4_proteina_bruta === null || tabela?.camp_4_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_4_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_gordura_bruta === null || tabela?.camp_4_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_4_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_organoleticos === undefined ? '' : tabela?.camp_4_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_nutritivos === undefined ? '' : tabela?.camp_4_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_ambientais === undefined ? '' : tabela?.camp_4_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_melhoradores_digestinais === undefined ? '' : tabela?.camp_4_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_4_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_outros_zootecnicos === undefined ? '' : (tabela?.camp_4_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_4_fosforo_total === null || tabela?.camp_4_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_4_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead> {"Bovinos Machos de 1 ano a < 2 anos"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_5_proteina_bruta === null || tabela?.camp_5_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_5_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_gordura_bruta === null || tabela?.camp_5_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_5_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_organoleticos === undefined ? '' : tabela?.camp_5_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_nutritivos === undefined ? '' : tabela?.camp_5_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_ambientais === undefined ? '' : tabela?.camp_5_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_melhoradores_digestinais === undefined ? '' : tabela?.camp_5_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_5_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_outros_zootecnicos === undefined ? '' : (tabela?.camp_5_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_5_fosforo_total === null || tabela?.camp_5_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_5_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>{"Bovinos Fêmeas de 1 ano a < 2 anos"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_6_proteina_bruta === null || tabela?.camp_6_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_6_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_gordura_bruta === null || tabela?.camp_6_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_6_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_organoleticos === undefined ? '' : tabela?.camp_6_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_nutritivos === undefined ? '' : tabela?.camp_6_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_ambientais === undefined ? '' : tabela?.camp_6_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_melhoradores_digestinais === undefined ? '' : tabela?.camp_6_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_6_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_outros_zootecnicos === undefined ? '' : (tabela?.camp_6_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_6_fosforo_total === null || tabela?.camp_6_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_6_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>{"Bovinos Machos com ≥ 2 anos"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_7_proteina_bruta === null || tabela?.camp_7_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_7_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_gordura_bruta === null || tabela?.camp_7_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_7_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_organoleticos === undefined ? '' : tabela?.camp_7_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_nutritivos === undefined ? '' : tabela?.camp_7_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_ambientais === undefined ? '' : tabela?.camp_7_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_melhoradores_digestinais === undefined ? '' : tabela?.camp_7_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_7_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_outros_zootecnicos === undefined ? '' : (tabela?.camp_7_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_7_fosforo_total === null || tabela?.camp_7_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_7_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>   {"Bovinos Fêmeas com >= 2 anos"}</StyledTableHead>
                      <StyledTableCell>{tabela?.camp_8_proteina_bruta === null || tabela?.camp_8_proteina_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_8_proteina_bruta)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_gordura_bruta === null || tabela?.camp_8_gordura_bruta === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_8_gordura_bruta)} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_organoleticos === undefined ? '' : tabela?.camp_8_organoleticos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_nutritivos === undefined ? '' : tabela?.camp_8_nutritivos}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_ambientais === undefined ? '' : tabela?.camp_8_ambientais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_melhoradores_digestinais === undefined ? '' : tabela?.camp_8_melhoradores_digestinais} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_estabilizadores_floragastrica === undefined ? '' : tabela?.camp_8_estabilizadores_floragastrica} </StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_outros_zootecnicos === undefined ? '' : (tabela?.camp_8_outros_zootecnicos)}</StyledTableCell>
                      <StyledTableCell>{tabela?.camp_8_fosforo_total === null || tabela?.camp_8_fosforo_total === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_8_fosforo_total)}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>{"TOTAL (Bovinos < 6 meses)"}</StyledTableHead>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }}>{tabela?.total_bovinos_menor === undefined || tabela?.total_bovinos_menor === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_bovinos_menor)}</StyledTableCell>
                      {/* <StyledTableCell sx={{ backgroundColor: "lightgray" }}>{formatarNumero_recebido_com_casa_decimais(total_proteina_bruta_menor_6(tabela?.camp_1_proteina_bruta, alimento_composto_1, tabela?.camp_2_proteina_bruta, alimento_composto_2))}</StyledTableCell> */}
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>{tabela?.total_gordura === undefined || tabela?.total_gordura === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_gordura)}</StyledTableCell>
                      {/* <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>{formatarNumero_recebido_com_casa_decimais(total_gordura_bruta(alimento_composto_total, tabela?.camp_1_gordura_bruta, alimento_composto_1, tabela?.camp_2_gordura_bruta, alimento_composto_2, tabela?.camp_1_gordura_bruta, alimento_composto_3, tabela?.camp_4_gordura_bruta, alimento_composto_4, tabela?.camp_5_gordura_bruta, alimento_composto_5, tabela?.camp_6_gordura_bruta, alimento_composto_6, tabela?.camp_7_gordura_bruta, alimento_composto_7, tabela?.camp_8_gordura_bruta, alimento_composto_8))}</StyledTableCell> */}
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>
                        {tabela?.total_organoleticos === undefined || tabela?.total_organoleticos === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_organoleticos)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>
                        {tabela?.total_nutritivos === undefined || tabela?.total_nutritivos === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_nutritivos)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>
                        {tabela?.total_ambientais === undefined || tabela?.total_ambientais === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_ambientais)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>
                        {tabela?.total_melhorados === undefined || tabela?.total_melhorados === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_melhorados)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>
                        {tabela?.total_estabilizadores === undefined || tabela?.total_estabilizadores === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_estabilizadores)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>
                        {tabela?.total_otros_zoote === undefined || tabela?.total_otros_zoote === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_otros_zoote)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>{tabela?.total_fosforo === undefined || tabela?.total_fosforo === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_fosforo)}</StyledTableCell>
                      {/* <StyledTableCell sx={{ backgroundColor: "lightgray" }} rowSpan={2}>{formatarNumero_recebido_com_casa_decimais(total_fosforo_total(alimento_composto_total, tabela?.camp_1_fosforo_total, alimento_composto_1, tabela?.camp_2_fosforo_total, alimento_composto_2, tabela?.camp_1_fosforo_total, alimento_composto_3, tabela?.camp_4_fosforo_total, alimento_composto_4, tabela?.camp_5_fosforo_total, alimento_composto_5, tabela?.camp_6_fosforo_total, alimento_composto_6, tabela?.camp_7_fosforo_total, alimento_composto_7, tabela?.camp_8_fosforo_total, alimento_composto_8))}</StyledTableCell> */}
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>{"TOTAL (Bovinos ≥ 6 meses)"}</StyledTableHead>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }}>{tabela?.total_bovinos_maior === undefined || tabela?.total_bovinos_maior === null ? 0 : formatarNumero_recebido_com_casa_decimais(tabela?.total_bovinos_maior)}</StyledTableCell>
                      {/* <StyledTableCell sx={{ backgroundColor: "lightgray" }}>{formatarNumero_recebido_com_casa_decimais(total_proteina_bruta_maior_ou_igual_6(alimento_composto_total, alimento_composto_1, alimento_composto_2, tabela?.camp_3_proteina_bruta, alimento_composto_3, tabela?.camp_4_proteina_bruta, alimento_composto_4, tabela?.camp_5_proteina_bruta, alimento_composto_5, tabela?.camp_6_proteina_bruta, alimento_composto_6, tabela?.camp_7_proteina_bruta, alimento_composto_7, tabela?.camp_8_proteina_bruta, alimento_composto_8))}</StyledTableCell> */}
                    </TableRow>
                  </>}
              </TableBody>
            </table>
          </TableContainer>
          <ConfirmDialog
            open={openDelete}
            onClose={() => setOpenDelete(false)}
            onConfirm={handleDelete}
            message="Deseja eliminar o registo?"
          />
        </>
      }

    </>
  );
};
